import { render, staticRenderFns } from "./ApproveRule.vue?vue&type=template&id=0f4533bf&scoped=true&"
import script from "./ApproveRule.vue?vue&type=script&lang=js&"
export * from "./ApproveRule.vue?vue&type=script&lang=js&"
import style0 from "./ApproveRule.vue?vue&type=style&index=0&id=0f4533bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4533bf",
  null
  
)

export default component.exports